var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-modal",
    {
      staticClass: "action-detail-modal",
      attrs: {
        title: _vm._f("actionTypeTitle")(_vm.action.__typename, _vm.action),
        padding: false,
      },
      on: { close: _vm.cancel },
    },
    [
      _c("ui-view-panel", [
        _c("tr", [
          _c("td", { staticClass: "key" }, [_vm._v("Datum")]),
          _c("td", [_vm._v(_vm._s(_vm._f("date")(_vm.action.date, "LL")))]),
        ]),
        _vm.isKeyAvailable("ship") && _vm.action.ship
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Schip")]),
              _c("td", [_vm._v(_vm._s(_vm.action.ship.name))]),
            ])
          : _vm._e(),
        _c("tr", [
          _c("td", { staticClass: "key" }, [_vm._v("Actie")]),
          _c("td", [
            _vm._v(
              _vm._s(_vm._f("actionTypeTitle")(_vm.actionType, _vm.action))
            ),
          ]),
        ]),
        _vm.isKeyAvailable("originLocation")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Oorsprong")]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm._f("empty")(_vm.action.originLocation)) +
                    " " +
                    _vm._s(_vm._f("originType")(_vm.action.originType)) +
                    " " +
                    _vm._s(_vm.action.seedYear)
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("mziArea")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("MZI gebied")]),
              _c("td", [_vm._v(_vm._s(_vm._f("empty")(_vm.action.mziArea)))]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("duration")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [
                _vm._v("MZI: Aantal uur gevist"),
              ]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm._f("empty")(_vm._f("number")(_vm.action.duration)))
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("fishingArea")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Visgebied")]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("empty")(_vm.action.fishingArea))),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("fishingWeight")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Visgewicht")]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("empty")(_vm.action.fishingWeight))),
              ]),
            ])
          : _vm._e(),
        _vm.action.originParcel
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Herkomst perceel")]),
              _c(
                "td",
                [
                  _vm.action.originParcel.alias != null
                    ? [_vm._v(_vm._s(_vm.action.originParcel.alias))]
                    : [
                        _vm._v(
                          _vm._s(_vm.action.originParcel.parcelLocation.name) +
                            " " +
                            _vm._s(
                              _vm.action.originParcel.parcelLocation.number
                            )
                        ),
                      ],
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("brutoWeight")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Bruto")]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(_vm._f("number")(_vm.action.brutoWeight))
                  ) + " mTon"
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("nettoWeight")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Netto")]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(_vm._f("number")(_vm.action.nettoWeight))
                  ) + " mTon"
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("brutoWeight")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Gewicht")]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(
                      _vm._f("number")(_vm.action.brutoWeight * 100)
                    )
                  ) + " kg"
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("tarra")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Tarra")]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm._f("empty")(_vm._f("number")(_vm.action.tarra))) +
                    "%"
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("bustal")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Bustal")]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm._f("empty")(_vm._f("number")(_vm.action.bustal)))
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("stukstal")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Stukstal")]),
              _c("td", [
                _vm._v(
                  _vm._s(_vm._f("empty")(_vm._f("number")(_vm.action.stukstal)))
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("brutoWeight") || _vm.isKeyAvailable("nettoWeight")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Zaaidichtheid")]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(
                      _vm._f("number")(
                        (_vm.action.brutoWeight || _vm.action.nettoWeight) /
                          _vm.section.size
                      )
                    )
                  ) + " mTon/ha"
                ),
              ]),
            ])
          : _vm._e(),
        _vm.action.sowingSection
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Doel")]),
              _c("td", [
                _vm._v(
                  "Verzaaid naar " +
                    _vm._s(_vm._f("parcel")(_vm.action.sowingSection.parcel)) +
                    ", Vak: " +
                    _vm._s(_vm.action.sowingSection.name)
                ),
              ]),
            ])
          : _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Doel")]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("actionTypeTitle")(_vm.action.__typename, _vm.action)
                  ) +
                    " op " +
                    _vm._s(_vm._f("parcel")(_vm.parcel)) +
                    ", Vak: " +
                    _vm._s(_vm.section.name) +
                    " "
                ),
              ]),
            ]),
        _vm.isKeyAvailable("fishingDuration") &&
        _vm.action.fishingDuration != null
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Visuren")]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("empty")(
                      _vm._f("number")(_vm.action.fishingDuration.duration)
                    )
                  ) + " min"
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("notes")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Bijzonderheden")]),
              _c("td", [_vm._v(_vm._s(_vm._f("empty")(_vm.action.notes)))]),
            ])
          : _vm._e(),
        _vm.isKeyAvailable("emptied")
          ? _c("tr", [
              _c("td", { staticClass: "key" }, [_vm._v("Leeggevist")]),
              _c("td", [_vm._v(_vm._s(_vm._f("bool")(_vm.action.emptied)))]),
            ])
          : _vm._e(),
      ]),
      _vm.treatment
        ? _c(
            "div",
            [
              _c("h3", [_vm._v("Behandeling")]),
              _c("ui-view-panel", [
                _c("tr", [
                  _c("td", { staticClass: "key" }, [_vm._v("Behandeling")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm._f("empty")(_vm.treatment.treatment))),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "key" }, [_vm._v("Duur")]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("empty")(
                          _vm._f("number")(_vm.treatment.duration)
                        )
                      ) + " uur"
                    ),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "key" }, [_vm._v("Bijzonderheden")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm._f("empty")(_vm.treatment.notes))),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.action.actionImages?.items?.length > 0
        ? _c("ui-panel", { staticClass: "images-panel" }, [
            _c("h2", { staticClass: "title" }, [_vm._v("Foto's")]),
            _c(
              "div",
              { staticClass: "image-container" },
              _vm._l(_vm.action.actionImages.items, function (n, index) {
                return _c("img", {
                  staticClass: "image",
                  attrs: { src: n.url },
                  on: {
                    click: function ($event) {
                      return _vm.openPhotoViewer(_vm.action, n, index)
                    },
                  },
                })
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }